import React, { Component } from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';
import ReactTooltip from 'react-tooltip';
import InventoryOnOrderSegment from './InventoryOnOrderSegment';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {api} from '../../../api';

class InventoryOnOrderToolTip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list: []
        }
    }

    onMouseEnter = () => {
        const {id, name, jwt} = this.props;
        if (_.isEmpty(this.state.list)) {
            this.setState({
                loading: true
            }, () => {
                api.inventory.onOrder(jwt, id).then(res => {
                    const {data} = res.data;
                    this.setState({
                        loading: false,
                        list: data
                    })
                })
            })
        }
    }

    onMouseLeft = () => {
        const {id, name} = this.props;
        
    }

    render() {
        const {name, refId} = this.props;
        const {list, loading} = this.state;
        return (
            <div onMouseEnter={() => {
                this.onMouseEnter();
            }}
            onMouseLeave={() => {
                this.onMouseLeft();
            }}>
                <strong><a data-tip data-for={refId} href='javascript:;'>{name}</a></strong>
                <ReactTooltip id={refId} aria-haspopup='true' place="right">
                    {loading ? <div style={{padding: 25}}>
                        <Dimmer active>
                            <Loader />
                        </Dimmer>
                    </div> : <InventoryOnOrderSegment
                        list={_.isArray(list) ? list : []}
                    /> }
                </ReactTooltip>
            </div>
        )
    }
}

InventoryOnOrderToolTip.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    jwt: PropTypes.string.isRequired,
    refId: PropTypes.string.isRequired
};

export default InventoryOnOrderToolTip


// WEBPACK FOOTER //
// ./src/components/utils/others/InventoryOnOrderToolTips.js